/**
 * Strips the protocol and trailing slashes from a URL.
 * @param {string} url
 * @returns {string}
 */
const normalizeUrl = (url) => url.replace(/^[^:]+:/, "").replace(/\/+$/, "");

export default normalizeUrl;
